const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null
);

const isSocketConnectHttpError = (error: unknown, status: number): boolean => {
  if (error === status) {
    return true;
  }

  if (!isRecord(error)) {
    return false;
  }

  const { description, data, message } = error;

  if (description === status) {
    return true;
  }

  if (isRecord(data) && data.status === status) {
    return true;
  }

  if (typeof message === 'string' && new RegExp(`\\b${status}\\b`).test(message)) {
    return true;
  }

  return false;
};

export default isSocketConnectHttpError;
